<template>
  <CarouselBase :carousel-list="carouselList">
    <template #card="{ item }">
      <CardStories
        :title="item.name"
        :caption="item.caption"
        :image-url="item.imageUrl"
        :button-name="item.buttonName"
        :to="item.buttonUrl"
        :button-id="item.buttonId"
        :is-click-card="isClickCard"
      />
    </template>
  </CarouselBase>
</template>

<script setup lang="ts">
  import type { IStoriesCarousel } from '@/components/Shared/Carousel/types';

  interface IProps {
    carouselList: IStoriesCarousel[];
    isClickCard: boolean;
  }

  withDefaults(defineProps<IProps>(), {
    carouselList: () => [],
    isClickCard: true,
  });
</script>
